import { Injectable } from '@angular/core';
import { User, getAuth, onAuthStateChanged } from 'firebase/auth';
import { from, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TokenService {
  private token: string | null = null;

  constructor() {
    this.listenForTokenChanges();
  }

  private listenForTokenChanges() {
    const auth = getAuth();
    onAuthStateChanged(auth, async (user: User | null) => {
      if (user) {
        this.token = await user.getIdToken();
      } else {
        this.token = null;
      }
    });
  }

  async getToken(forceRefresh: boolean = false): Promise<string | null> {
    if (!this.token || forceRefresh) {
      const auth = getAuth();
      const user = auth.currentUser;
      if (user) {
        this.token = await user.getIdToken(forceRefresh);
      }
    }
    return this.token;
  }

  /**
   * Force refresh the Firebase ID token.
   * This method should be called when a 401 error is received to get a fresh token.
   */
  refreshToken(): Observable<string | null> {
    return from(this.forceRefreshToken());
  }

  private async forceRefreshToken(): Promise<string | null> {
    const auth = getAuth();
    const user = auth.currentUser;
    if (user) {
      try {
        // Force refresh the token from Firebase
        this.token = await user.getIdToken(true);
        return this.token;
      } catch (error) {
        console.error('Error refreshing token:', error);
        this.token = null;
        return null;
      }
    }
    return null;
  }

  clearToken() {
    this.token = null;
  }
}
